import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell';
import { AuthGate } from './components/AuthGate';
import { LoginPage } from './routes/LoginPage';
import { DashboardPage } from './routes/DashboardPage';
import { ComingSoon } from './routes/ComingSoon';
import { AgentsPage } from './routes/AgentsPage';
import { AgentCreatePage } from './routes/AgentCreatePage';
import { AgentBlueprintPage } from './routes/AgentBlueprintPage';
import { AgentSkillsPage } from './routes/AgentSkillsPage';
import { McpsPage } from './routes/McpsPage';
import { McpAddPage } from './routes/McpAddPage';
import { McpDetailPage } from './routes/McpDetailPage';
import { ChannelsPage } from './routes/ChannelsPage';
import { WhatsAppPage } from './routes/WhatsAppPage';
import { InboxPage } from './routes/InboxPage';
import { WorkflowsListPage } from './routes/WorkflowsListPage';
import { WorkflowEditorPage } from './routes/WorkflowEditorPage';

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<AuthGate />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<DashboardPage />} />

          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/agents/new" element={<AgentCreatePage />} />
          <Route path="/agents/new/blueprint" element={<AgentBlueprintPage />} />
          <Route path="/agents/:id" element={<AgentBlueprintPage />} />
          <Route path="/agents/:id/blueprint" element={<AgentBlueprintPage />} />
          <Route path="/agents/:id/skills" element={<AgentSkillsPage />} />
          <Route
            path="/agents/:id/test"
            element={<ComingSoon title="Test console" phase="Phase 9" />}
          />

          <Route path="/inbox" element={<InboxPage />} />
          <Route path="/inbox/:id" element={<InboxPage />} />
          <Route path="/channels" element={<ChannelsPage />} />
          <Route path="/channels/whatsapp" element={<WhatsAppPage />} />
          <Route path="/channels/whatsapp/:sessionId" element={<WhatsAppPage />} />
          <Route path="/mcp-tools" element={<McpsPage />} />
          <Route path="/mcp-tools/new" element={<McpAddPage />} />
          <Route path="/mcp-tools/:id" element={<McpDetailPage />} />
          <Route path="/skills" element={<ComingSoon title="Skills (config)" phase="Phase 3+" />} />
          <Route path="/workflows" element={<WorkflowsListPage />} />
          <Route path="/workflows/new" element={<WorkflowEditorPage />} />
          <Route path="/workflows/:id" element={<WorkflowEditorPage />} />
          <Route path="/knowledge" element={<ComingSoon title="Knowledge" phase="Phase 10" />} />
          <Route path="/analytics" element={<ComingSoon title="Analytics" phase="Phase 10" />} />
          <Route path="/governance" element={<ComingSoon title="Governance" phase="Phase 10" />} />
          <Route path="/settings" element={<ComingSoon title="Settings" phase="Phase 10" />} />
          <Route path="*" element={<ComingSoon title="Not found" phase="—" />} />
        </Route>
      </Route>
    </Routes>
  );
}
